import React, { useRef, useEffect, useState, useCallback, useMemo } from 'react'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { fetchCompanyProfiles } from '../../../../store/slices/companyProfileSlice';
import { fetchLeads } from '../../../../store/slices/leadsSlice';
import AdminLoader from '../../../../components/common/loader/AdminLoader';
import { fetchAllProjects } from '../../../../store/slices/projectsSlice';
import { createQuotation, downloadQuotationFile, editGenerateQuotation, fetchAllQuotations, sendQuotationToClient } from '../../../../store/slices/generateQuotationSlice';
import { fetchAllQuotationTemplates } from '../../../../store/slices/QuotationTemplateSlice';
import FileViewer from '../../../Operations/SalesOperations/SalesFinance/CreateQuotation/FileViewer';
import { fetchFilesByLeadId } from '../../../../store/slices/fileSlice';
import FilesViewer from '../../../lead/FilesViewer';
import ReactQuill from 'react-quill';
import SalesCalculations from '../../../Operations/SalesOperations/SalesFinance/TableSalesFinance/SalesCalculations';
import { setCurrentPageTitle, setcurrentLeadID } from '../../../../store/slices/pageSlice';
import { resetStep, setCreatedProject, goToStep, setOperationProjectStatus, setExistingSearchGroupName, setExistingSearchClientName, setExistingSearchProjectName, setExistingProjectLeadId, setExistingEditAdvancedProject, setExistingSearchQuotationID } from '../../../../store/slices/WizardSlice/wizardStepSlice';
import { setShowWizard } from '../../../../store/slices/WizardSlice/WizardSlice';
import useSubscriptionLevel from '../../../../utils/SubscriptionLevel';
import configApi from '../../../../config/api';
import { useCurrencySymbol } from '../../../../utils/currencyUtils';
import CommaConvert from '../../../../utils/CommaConvert';

const GenerateQuotationWizard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const quillRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const subscriptionPackage = useSubscriptionLevel();
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();
    const [isTemplateOpen, setIsTemplateOpen] = useState(false);
    const [isHistoryOpen, setisHistoryOpen] = useState(false);
    const [AssignedGroup, setAssignedGroup] = useState("All");
    const [template, settemplate] = useState([]);
    const { templates } = useSelector((state) => state.quotationTemplates);
    const [value, setValue] = useState('');
    const { profiles } = useSelector(state => state.companyProfile);
    const { leads } = useSelector((state) => state.leads);
    const createdProject = useSelector((state) => state.wizardstep.createdProject);
    const wizardPlanState = useSelector((state) => state.wizardstep.wizardPlanState);
    const wizardProjectState = useSelector((state) => state.wizardstep.wizardProjectState);
    const [selectedLead, setSelectedLead] = useState(null);
    const [selectedTemplate, setselectedTemplate] = useState('');
    const [replacedData, setReplacedData] = useState("");
    const [isLoading, SetisLoading] = useState(false);
    const [Templateid, setTemplateid] = useState(null);
    const [autosaveid, setautosaveid] = useState(null);
    const [leadid, setleadid] = useState(null);
    const [sendid, setsendid] = useState(null);
    const [downloadid, setdownloadid] = useState(null);
    const { quotations } = useSelector(state => state.generateQuotation);
    const [, sethistoryid] = useState("");
    const [files, setFiles] = useState([]);
    const [, setHasInstallationTable] = useState(false);
    const [, setHasAssociatedTable] = useState(false);
    const [installationPLTableHtml,] = useState('');
    const [SalesFinanceEffortstableHtml,] = useState('');
    const [, setHasEffortTable] = useState(false);
    const [, setfinanaceData] = useState('');
    const [, setprojectCostMap] = useState('');
    const [htmlString, sethtml] = useState('');
    const [fileName, sefileName] = useState([]);
    const [showfile, seshowfile] = useState([]);
    const [quotation, sequotations] = useState([]);
    const debounceTimeoutRef = useRef(null);
    const [showVersionHistoryHint, setShowVersionHistoryHint] = useState(false);
    const resolvedCompanyLogoUrl = useMemo(() => {
        const profile = profiles?.[0];
        // Sidebar footer uses `profiles[0].logoPath` directly.
        // Prefer `logoPath` first so CRM Wizard matches Sidebar/ERP behavior.
        const raw = String(
            profile?.logoPath || profile?.companylogo || profile?.companyLogo || ''
        ).trim();
        if (!raw) return '';

        let absoluteUrl = raw;
        const isAbsolute =
            /^https?:\/\//i.test(raw) || /^data:/i.test(raw) || /^blob:/i.test(raw);
        if (!isAbsolute) {
            const backendUrl = String(configApi?.backendUrl || '').trim();
            const backendOrigin = backendUrl.replace(/\/api\/?$/i, '').replace(/\/$/, '');
            const normalizedPath = raw.replace(/^\.?\//, '');
            absoluteUrl = backendOrigin
                ? `${backendOrigin}/${normalizedPath}`
                : normalizedPath;
        }

        const stamp = profile?.updatedAt || profile?._id || '';
        if (!stamp) return absoluteUrl;
        return absoluteUrl.includes('?')
            ? `${absoluteUrl}&v=${encodeURIComponent(String(stamp))}`
            : `${absoluteUrl}?v=${encodeURIComponent(String(stamp))}`;
    }, [profiles]);

    useEffect(() => {
        const p = profiles?.[0];
        if (!p) return;
        console.log("Company Logo:", {
            logoPath: p?.logoPath,
            companylogo: p?.companylogo,
            companyLogo: p?.companyLogo,
            resolvedCompanyLogoUrl,
        });
    }, [profiles, resolvedCompanyLogoUrl]);

    const stripCompanyLogoPlaceholderFromHtml = useCallback((html) => {
        if (!html || typeof html !== "string") return html;
        try {
            const doc = new DOMParser().parseFromString(html, "text/html");
            // Remove literal placeholder text nodes.
            const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
            const toRemove = [];
            while (walker.nextNode()) {
                const n = walker.currentNode;
                if (!n) continue;
                const t = String(n.nodeValue || "").trim();
                if (t === "Company Logo") toRemove.push(n);
            }
            toRemove.forEach((n) => n.parentNode?.removeChild(n));

            // Remove empty/broken logo-ish images.
            Array.from(doc.querySelectorAll("img")).forEach((img) => {
                const src = String(img.getAttribute("src") || "").trim();
                const alt = String(img.getAttribute("alt") || "").trim().toLowerCase();
                if (!src && alt.includes("company")) img.remove();
                if (src === "undefined" || src === "null") img.remove();
            });

            return doc.body.innerHTML;
        } catch {
            // fallback: best-effort string removal
            return html.replace(/Company Logo/g, "");
        }
    }, []);

    /** Remove data-URI / wizard test uploads from CRM template HTML loaded from URL only (not at generate time). */
    const stripCrmPersistedInlineImagesFromQuotationBody = useCallback((html) => {
        if (!html || typeof html !== "string") return html;
        try {
            const doc = new DOMParser().parseFromString(html, "text/html");
            doc.querySelectorAll("img[src]").forEach((img) => {
                const src = String(img.getAttribute("src") || "").trim();
                const alt = String(img.getAttribute("alt") || "").trim().toLowerCase();
                if (/^data:image/i.test(src) || alt === "uploaded image") {
                    img.remove();
                }
            });
            return doc.body.innerHTML;
        } catch {
            return html.replace(/<img[^>]*\ssrc=["']data:image[^"']*["'][^>]*>/gi, "");
        }
    }, []);

    const CRM_HEADER_MARKER = "<!-- CRM_QUOTATION_HEADER -->";
    const CRM_HEADER_EMAIL = "info@indusinformatics.com";

    const buildQuotationHeaderHtml = useCallback((logoUrl) => {
        const safeLogo = String(logoUrl || "").trim();
        return `
${CRM_HEADER_MARKER}
<div class="quotation-header" style="width:100%; display:flex; align-items:flex-start; justify-content:space-between; margin-top:6px;">
  <div style="flex:0 0 45%; display:flex; align-items:center;">
    ${
        safeLogo
            ? `<img src="${safeLogo.replace(/"/g, "&quot;")}" alt="Company Logo" style="max-height:60px;width:auto;object-fit:contain;display:block;" onerror="this.insertAdjacentHTML('afterend','<span>Company Logo</span>');this.remove();" />`
            : `<span>Company Logo</span>`
    }
  </div>
  <div style="flex:0 0 auto; width:1px; background:#000; height:60px; margin:0 14px;"></div>
  <div style="flex:1; text-align:right; font-size:12px; line-height:1.4; padding-top:10px;">
    <div><strong>Email:</strong> info@indusinformatics.com</div>
    <div><strong>Address:</strong> 4830, Osage Avenue,<br/>Philadelphia, PA 19143</div>
  </div>
</div>
<div style="margin-top:10px; border-top:2px solid #000;"></div>
`;
    }, []);

    const stripExistingCrmQuotationHeader = useCallback((html) => {
        if (!html || typeof html !== "string") return html;
        const raw = String(html);

        // Fast path: nothing to strip.
        if (!raw.includes(CRM_HEADER_MARKER) && !raw.toLowerCase().includes(CRM_HEADER_EMAIL)) {
            return raw;
        }

        try {
            const doc = new DOMParser().parseFromString(raw, "text/html");

            // 1) Preferred: remove the marked header block.
            const markerNode = (() => {
                // The marker comment is inside <body>, not at document root.
                const walker = doc.createTreeWalker(
                    doc.body,
                    NodeFilter.SHOW_COMMENT,
                    null
                );
                let n = walker.nextNode();
                while (n) {
                    if (
                        n.nodeType === Node.COMMENT_NODE &&
                        String(n.nodeValue || "").trim() === "CRM_QUOTATION_HEADER"
                    ) {
                        return n;
                    }
                    n = walker.nextNode();
                }
                return null;
            })();
            if (markerNode) {
                let current = markerNode.nextSibling;
                markerNode.parentNode?.removeChild(markerNode);

                // Remove the next header container (and the divider below it) if present.
                while (current && current.nodeType === Node.TEXT_NODE && !String(current.textContent || "").trim()) {
                    const next = current.nextSibling;
                    current.parentNode?.removeChild(current);
                    current = next;
                }

                if (current && current.nodeType === Node.ELEMENT_NODE) {
                    const el = current;
                    const isHeader = el.classList?.contains("quotation-header");
                    if (isHeader) {
                        const headerNext = el.nextSibling;
                        el.parentNode?.removeChild(el);

                        // divider line directly after header
                        if (headerNext && headerNext.nodeType === Node.ELEMENT_NODE) {
                            const divEl = headerNext;
                            const style = String(divEl.getAttribute("style") || "").replace(/\s+/g, " ").toLowerCase();
                            if (style.includes("border-top") && style.includes("2px")) {
                                divEl.parentNode?.removeChild(divEl);
                            }
                        }
                    }
                }

                return doc.body.innerHTML;
            }

            // 2) Fallback: remove first occurrence of the header container by email match.
            const emailNode = Array.from(doc.querySelectorAll("div")).find((d) =>
                String(d.textContent || "").toLowerCase().includes(CRM_HEADER_EMAIL)
            );
            if (emailNode) {
                const headerRoot = emailNode.closest(".quotation-header") || emailNode.closest("div");
                if (headerRoot) {
                    const headerNext = headerRoot.nextSibling;
                    headerRoot.parentNode?.removeChild(headerRoot);

                    if (headerNext && headerNext.nodeType === Node.ELEMENT_NODE) {
                        const divEl = headerNext;
                        const style = String(divEl.getAttribute("style") || "").replace(/\s+/g, " ").toLowerCase();
                        if (style.includes("border-top") && style.includes("2px")) {
                            divEl.parentNode?.removeChild(divEl);
                        }
                    }
                }
            }

            return doc.body.innerHTML;
        } catch {
            // Best-effort string fallback: drop everything up to the first divider line after header.
            const idx = raw.indexOf(CRM_HEADER_MARKER);
            if (idx >= 0) {
                return raw.slice(idx + CRM_HEADER_MARKER.length);
            }
            return raw;
        }
    }, []);

    // For CRM package: the header is rendered outside the editor UI and added only during Generate.
    // So the editor body must never persist the CRM header block (otherwise it duplicates visually and in generated output).
    const sanitizeCrmEditorHtml = useCallback(
        (html) => {
            let out = html;
            out = stripCompanyLogoPlaceholderFromHtml(out || "");
            out = stripExistingCrmQuotationHeader(out || "");
            return out;
        },
        [stripCompanyLogoPlaceholderFromHtml, stripExistingCrmQuotationHeader]
    );

    // Get selected group and project from createdProject
    const selectedGroup = createdProject[0]?.AssignedGroup || "";
    const selectedProject = createdProject[0]?.ProjectName || "";

    useEffect(() => {
        dispatch(setCurrentPageTitle("Generate Quotation"));
    }, [dispatch]);

    useEffect(() => {
        if (quotations?.length > 0 && leadid) {
            const filteredQuotations = quotations.filter(q => q.leadid === leadid);
            sequotations(filteredQuotations)
        }
    }, [quotations, leads, leadid]);

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                const files = await dispatch(fetchFilesByLeadId(leadid)).unwrap();
                seshowfile(files)
                const fileNames = files.map(file => file.fileName);
                sefileName(fileNames);
            } catch (err) {
                console.error("Error fetching files:", err);
            }
        };
        if (leadid) {
            fetchFiles();
        }
    }, [dispatch, leadid]);

    useEffect(() => {
        if (createdProject && createdProject.length > 0) {
            const filteredLeads = leads.filter(lead =>
                lead.ProjectName.toLowerCase().includes(createdProject[0]?.ProjectName?.toLowerCase())
            );
            if (filteredLeads.length > 0) {
                setleadid(filteredLeads[0].id);
                sethistoryid(filteredLeads[0].id)
                setSelectedLead(filteredLeads[0]);
            }
        }
    }, [leads, createdProject]);

    useEffect(() => {
        dispatch(fetchAllQuotations());
        dispatch(fetchAllQuotationTemplates());
        dispatch(fetchCompanyProfiles());
        dispatch(fetchLeads());
        dispatch(fetchAllProjects());
    }, [dispatch]);

    useEffect(() => {
        settemplate(templates);
    }, [templates]);

    const groupdownRef = useRef(null);
    const handleClickOutsidegroup = (e) => {
        if (groupdownRef.current && !groupdownRef.current.contains(e.target)) {
            setIsTemplateOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutsidegroup);
        return () => {
            document.removeEventListener("click", handleClickOutsidegroup);
        };
    }, []);

    const versionRef = useRef(null);
    const handleClickOutsideversion = React.useCallback((e) => {
        if (versionRef.current && !versionRef.current.contains(e.target)) {
            setisHistoryOpen(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener("click", handleClickOutsideversion);
        return () => {
            document.removeEventListener("click", handleClickOutsideversion);
        };
    }, [handleClickOutsideversion]);

    const replacePlaceholders = (html, lead, profile) => {
        if (!lead) return { processedHtml: html, replacedData: {} };

        const currentDate = new Date().toLocaleDateString();
        const subscriptionPackage = String(profile?.subscriptionpackage || '').trim().toUpperCase();
        const isCRM = subscriptionPackage === 'CRM';
        const isCRMOrERP = ['CRM', 'ERP'].includes(subscriptionPackage);

        const replacedData = {
            "Project Name": lead.ProjectName || '',
            "Client Name": lead.ClientName || '',
            "Current Date": currentDate,
            "Client Contact Name": lead.ClientContactName || '',
            "Client Contact Email": lead.ClientEmail || '',
            "Company Profile Name": profile?.companyname || '',
            "Company Profile Logo": isCRM ? '' : profile?.companylogo || '',
            "Company Profile Email": profile?.companyemail || '',
            "Company Profile Address": profile?.companyaddress || '',
            "File Names": fileName || "",
            "templateId": Templateid
        };

        if (isCRMOrERP) {
            replacedData["Structural Monitoring Proposal"] =
                "<div style='margin-top:16px;'>" +
                "<p style='margin:0 0 14px 0; text-align:center; font-weight:700;'>Structural Monitoring Proposal for Bridge Infrastructure</p>" +
                "<p style='margin:0 0 14px 0;'>To implement a reliable and scalable structural monitoring solution that provides continuous monitoring through high-precision accelerometers and visual inspection using intelligent camera systems.</p>" +
                "<p style='margin:0 0 10px 0; font-weight:700;'>1. Solution Overview</p>" +
                "<p style='margin:0 0 12px 0;'>Our STRUCTURAL MONITORING system integrates sensor-based vibration monitoring with visual inspection tools to provide comprehensive insights into structural performance. The system includes:</p>" +
                "<ul style='margin:0 0 14px 18px; padding-left:16px;'>" +
                "<li style='margin-bottom:6px;'><strong>Accelerometer Modules:</strong> For real-time measurement of vibrations, tilt, and dynamic structural responses.</li>" +
                "<li style='margin-bottom:6px;'><strong>Camera Modules:</strong> For periodic or event-triggered visual capture of the structure, enabling visual correlation with sensor data.</li>" +
                "<li><strong>Centralized Monitoring Interface:</strong> Displays synchronized data, alerts, and reports to the end-user.</li>" +
                "</ul>" +
                "<p style='margin:0 0 10px 0; font-weight:700;'>2. Key Features</p>" +
                "<ul style='margin:0 0 14px 18px; padding-left:16px;'>" +
                "<li style='margin-bottom:6px;'><strong>Time-Synchronized Data Acquisition:</strong> Sensor and camera data aligned to a timeframe.</li>" +
                "<li style='margin-bottom:6px;'><strong>Remote Monitoring Dashboard:</strong> Real-time access to data, event logs, and visual content.</li>" +
                "<li><strong>Threshold Alerts:</strong> Notifications triggered by abnormal vibration or tilt events.</li>" +
                "</ul>" +
                "</div>";

            replacedData["Project Background"] =
                "<div style='margin-top:20px;'>" +
                "<p style='margin:0 0 14px 0; text-align:center; font-weight:700;'>Project Background</p>" +
                "<p style='margin:0 0 12px 0;'>Webber has requested structural monitoring service for their <strong>Mid Toll Bridge, Destin Bridge and Brookes bridge</strong> located at Destin, Florida.</p>" +
                "<p style='margin:0 0 12px 0;'>To address this, <strong>Indus Informatics</strong> will implement a structural monitoring solution designed to provide real-time notifications of any structural response events using a combination of precision accelerometer and tilt sensor technologies. In the event of significant structural activity or displacement, <strong>Indus Informatics</strong> will issue automated alerts to designated WEBBER personnel via SMS, email and voice call.</p>" +
                "<p style='margin:0 0 10px 0;'>The Indus Informatics Structural Monitoring system consists of three core components:</p>" +
                "<ol style='margin:0 0 0 20px; padding-left:16px;'>" +
                "<li style='margin-bottom:6px;'><strong>Sensor Units</strong> &ndash; Capture and monitor dynamic and static structural behaviour (vibration, tilt, and temperature).</li>" +
                "<li style='margin-bottom:6px;'><strong>Communications &amp; Power Hub</strong> &ndash; Controls the system&rsquo;s operations and transmits data.</li>" +
                "<li><strong>Cloud-based Monitoring Platform</strong> &ndash; Receives and processes all incoming data for real-time analysis and alert generation.</li>" +
                "</ol>" +
                "</div>";
        }

        let processedHtml = html;
        Object.entries(replacedData).forEach(([key, value]) => {
            const regex = new RegExp(`{{${key}}}`, 'g');
            processedHtml = processedHtml.replace(regex, value);
        });

        const hasInstallation = html.includes('{{Installation P &amp; L Table}}');
        const hasAssociated = html.includes('{{Associated Installation Cost Table}}');
        const hasEmployeeEfforts = html.includes('{{Employee Efforts Table}}');

        if (hasInstallation) {
            processedHtml = processedHtml.replace(/{{Installation P &amp; L Table}}/g, '<!-- INSTALLATION_TABLE -->');
            setHasInstallationTable(true);
        }

        if (hasAssociated) {
            processedHtml = processedHtml.replace(/{{Associated Installation Cost Table}}/g, '<!-- ASSOCIATED_TABLE -->');
            setHasAssociatedTable(true);
        }
        if (hasEmployeeEfforts) {
            processedHtml = processedHtml.replace(/{{Employee Efforts Table}}/g, '<!-- Employee_Efforts -->');
            setHasEffortTable(true);
        }

        // CRM: editable Finance Summary + optional Hardware Details
        const hasSummaryTables = html.includes('{{Summary Tables}}');
        if (hasSummaryTables && isCRM) {
            const cellStyle =
                "border: 1px solid #000; padding: 8px; min-width: 80px; min-height: 32px;";

            const serviceTypesArrCandidate =
                lead?.servicetypes ??
                lead?.serviceTypes ??
                lead?.ServiceTypes ??
                lead?.TypeService ??
                [];

            const serviceTypes = (() => {
                const toTypeName = (st) => {
                    if (!st) return "";
                    if (typeof st === "string") return st;
                    return (
                        st.TypeService ||
                        st.typeService ||
                        st.ServiceType ||
                        st.serviceType ||
                        st.type ||
                        ""
                    );
                };

                if (Array.isArray(serviceTypesArrCandidate)) {
                    return serviceTypesArrCandidate.map(toTypeName).filter(Boolean);
                }

                if (
                    serviceTypesArrCandidate &&
                    Array.isArray(serviceTypesArrCandidate.TypeService)
                ) {
                    return serviceTypesArrCandidate.TypeService
                        .map(toTypeName)
                        .filter(Boolean);
                }

                if (
                    serviceTypesArrCandidate &&
                    Array.isArray(serviceTypesArrCandidate.serviceTypes)
                ) {
                    return serviceTypesArrCandidate.serviceTypes
                        .map(toTypeName)
                        .filter(Boolean);
                }

                return [];
            })();

            const quotedTotal =
                lead?.quotedprice ??
                lead?.quotedPrice ??
                lead?.QuotedPrice ??
                lead?.QuotedValue ??
                0;

            const safeTotal = Number(quotedTotal) || 0;

            const isUSA = String(currency || "").trim() === "$";
            const onInputFormat = isUSA
                ? "let v=(this.value||'').toString().replace(/[^0-9]/g,''); this.value=v.replace(/\\B(?=(\\d{3})+(?!\\d))/g, ',');"
                : "let v=(this.value||'').toString().replace(/[^0-9]/g,''); if(v.length<=3){this.value=v;return;} let last3=v.slice(-3); let other=v.slice(0,-3); other=other.replace(/\\B(?=(\\d{2})+(?!\\d))/g, ','); this.value=other+','+last3;";

            const priceHeader = currency ? `Price (${currency})` : "Price";

            const hasHardwareService = serviceTypes.some(
                (st) => String(st || "").trim().toLowerCase() === "hardware"
            );
            const safeServiceTypes = serviceTypes.map((serviceType) =>
                String(serviceType).replace(/</g, "&lt;")
            );

            let tableHtml = `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 520px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center; font-size: 14px;">Finance Summary</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Service types</th><th style="${cellStyle} text-align: right;">${priceHeader}</th></tr></thead><tbody>${safeServiceTypes
                .map((serviceType, idx) => {
                    return `<tr style="background-color: #fff;"><td style="${cellStyle}">${serviceType}</td><td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="servicePrice_${idx}" value="" onkeydown="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeypress="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeyup="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onbeforeinput="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();" oninput="${onInputFormat}; this.setAttribute('value', this.value);" /></td></tr>`;
                })
                .join("")}<tr style="background-color: #bfdbfe; font-weight: bold;"><td style="${cellStyle}">Total quoted price</td><td style="${cellStyle} text-align: right;">${USAComma(Number(safeTotal).toFixed(2))}</td></tr></tbody></table></div></div>`;

            if (hasHardwareService) {
                tableHtml += `<div style="margin: 12px 0; display: flex; justify-content: center;"><div style="width: 100%; max-width: 520px;"><p style="font-weight: bold; margin-bottom: 8px; text-align: center; font-size: 14px;">Hardware Details</p><table style="width: 100%; border-collapse: collapse; font-size: 12px; border: 1px solid #000; margin: 0 auto;"><thead><tr style="background-color: #e7ebfb;"><th style="${cellStyle} text-align: left;">Part name</th><th style="${cellStyle} text-align: right;">Part qty</th></tr></thead><tbody><tr style="background-color: #fff;"><td style="${cellStyle}"><input type="text" style="width: 100%; border: none; outline: none; text-align: left; font-size: 12px;" name="hardwarePartName_0" value="" onkeydown="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeypress="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeyup="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onbeforeinput="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();" oninput="this.setAttribute('value', this.value);" /></td><td style="${cellStyle} text-align: right;"><input type="text" inputmode="numeric" style="width: 100%; border: none; outline: none; text-align: right; font-size: 12px;" name="hardwarePartQty_0" value="" onkeydown="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeypress="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onkeyup="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onbeforeinput="event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();" onmousedown="event.stopPropagation();" onclick="event.stopPropagation();" oninput="this.value=(this.value||'').toString().replace(/[^0-9]/g,''); this.setAttribute('value', this.value);" /></td></tr></tbody></table><div style="display:flex; justify-content:flex-end; gap:8px; margin-top:8px;"><button type="button" style="padding:2px 10px; border:1px solid #000; background:#fff; cursor:pointer; font-size:12px;" onclick="(function(btn){var table=btn.closest('div').previousElementSibling; if(!table) return; var tbody=table.querySelector('tbody'); if(!tbody) return; var rowCount=tbody.querySelectorAll('tr').length; var uid=Date.now()+''+Math.floor(Math.random()*1000); var tr=document.createElement('tr'); tr.style.backgroundColor='#fff'; tr.innerHTML='<td style=&quot;${cellStyle}&quot;><input type=&quot;text&quot; style=&quot;width:100%; border:none; outline:none; text-align:left; font-size:12px;&quot; name=&quot;hardwarePartName_'+uid+'&quot; value=&quot;&quot; onkeydown=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeypress=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeyup=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onbeforeinput=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onmousedown=&quot;event.stopPropagation();&quot; onclick=&quot;event.stopPropagation();&quot; oninput=&quot;this.setAttribute(\\'value\\', this.value);&quot; /></td><td style=&quot;${cellStyle} text-align:right;&quot;><input type=&quot;text&quot; inputmode=&quot;numeric&quot; style=&quot;width:100%; border:none; outline:none; text-align:right; font-size:12px;&quot; name=&quot;hardwarePartQty_'+uid+'&quot; value=&quot;&quot; onkeydown=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeypress=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onkeyup=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onbeforeinput=&quot;event.stopPropagation(); event.stopImmediatePropagation && event.stopImmediatePropagation();&quot; onmousedown=&quot;event.stopPropagation();&quot; onclick=&quot;event.stopPropagation();&quot; oninput=&quot;this.value=(this.value||\\'\\').toString().replace(/[^0-9]/g,\\'\\'); this.setAttribute(\\'value\\', this.value);&quot; /></td>'; tbody.appendChild(tr);})(this)">+</button><button type="button" style="padding:2px 10px; border:1px solid #000; background:#fff; cursor:pointer; font-size:12px;" onclick="(function(btn){var table=btn.closest('div').previousElementSibling; if(!table) return; var tbody=table.querySelector('tbody'); if(!tbody) return; var rows=tbody.querySelectorAll('tr'); if(rows.length<=1) return; tbody.removeChild(rows[rows.length-1]);})(this)">-</button></div></div></div>`;
            }

            processedHtml = processedHtml.replace(/{{Summary Tables}}/g, tableHtml);
        }

        processedHtml = processedHtml.replace(/{{[^}]+}}/g, '');

        if (isCRMOrERP) {
            let formatted = processedHtml;
            const rawLogo =
                resolvedCompanyLogoUrl ||
                profile?.companylogo ||
                profile?.logoPath ||
                profile?.companyLogo ||
                '';
            const safeLogoUrl = (() => {
                const s = String(rawLogo || '').trim();
                if (!s) return '';
                if (s === 'undefined' || s === 'null') return '';
                return s;
            })();

            const dateParaRegex = /<p>\s*Date:\s*([^<]+)\s*<\/p>/i;
            const dateMatch = formatted.match(dateParaRegex);
            if (dateMatch) {
                const dt = String(dateMatch[1] || '').trim();
                formatted = formatted.replace(dateParaRegex, '');
                formatted = `<p style="text-align:right; margin:0 0 10px 0;">Date: ${dt}</p>${formatted}`;
            } else {
                const dateTextRegex = /Date:\s*([^<\n\r]+)/i;
                const dateTextMatch = formatted.match(dateTextRegex);
                if (dateTextMatch) {
                    const dt = String(dateTextMatch[1] || '').trim();
                    formatted = formatted.replace(dateTextRegex, '');
                    formatted = `<p style="text-align:right; margin:0 0 10px 0;">Date: ${dt}</p>${formatted}`;
                }
            }

            formatted = formatted.replace(
                /<p>\s*To,\s*"([^"]+)"\s*<\/p>/gi,
                (_m, clientName) => `<p>To,</p><p>${String(clientName || '').trim()}</p>`
            );
            formatted = formatted.replace(
                /To,\s*"([^"]+)"\s*/gi,
                (_m, clientName) => `To,<br/>${String(clientName || '').trim()}`
            );
            formatted = formatted.replace(
                /<p>\s*Dear\s*"([^"]+)"\s*,\s*<\/p>/gi,
                (_m, clientName) => `<p>Dear ${String(clientName || '').trim()},</p>`
            );
            formatted = formatted.replace(
                /Dear\s*"([^"]+)"\s*,/gi,
                (_m, clientName) => `Dear ${String(clientName || '').trim()},`
            );

            // ERP: keep header inside template (existing behavior).
            // CRM: do NOT inject logo into editor HTML; we'll render it outside and prepend it during Generate.
            if (subscriptionPackage === "ERP") {
                processedHtml = buildQuotationHeaderHtml(safeLogoUrl) + formatted;
            } else {
                processedHtml = stripCompanyLogoPlaceholderFromHtml(formatted);
            }
        }

        return { processedHtml, replacedData };
    };

    const loadTemplate = async (tplUrl) => {
        try {
            const res = await fetch(tplUrl);
            if (!res.ok) throw new Error("Failed to fetch template");

            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            let content = doc.body.innerHTML;

            const profile = profiles.length > 0 ? profiles[0] : null;
            const { processedHtml, replacedData } = replacePlaceholders(content, selectedLead, profile);
            let finalHtml = processedHtml;
            if (processedHtml.includes('<!-- INSTALLATION_TABLE -->') && installationPLTableHtml) {
                finalHtml = finalHtml.replace('<!-- INSTALLATION_TABLE -->', installationPLTableHtml);
            }
            if (processedHtml.includes('<!-- ASSOCIATED_TABLE -->') && SalesFinanceEffortstableHtml) {
                finalHtml = finalHtml.replace('<!-- ASSOCIATED_TABLE -->', SalesFinanceEffortstableHtml);
            }
            if (processedHtml.includes('<!-- Employee_Efforts -->') && htmlString) {
                finalHtml = finalHtml.replace('<!-- Employee_Efforts -->', htmlString);
            }

            // CRM: ensure placeholder text is not visible in editor once template is loaded.
            // (Logo is rendered outside editor in UI + prepended during Generate.)
            const subscriptionPackage = String(profile?.subscriptionpackage || '')
                .trim()
                .toUpperCase();
            if (subscriptionPackage === "CRM") {
                finalHtml = stripCompanyLogoPlaceholderFromHtml(finalHtml);
                finalHtml = stripCrmPersistedInlineImagesFromQuotationBody(finalHtml);
                finalHtml = sanitizeCrmEditorHtml(finalHtml);
            }
            setValue(finalHtml);
            setReplacedData(replacedData);
        } catch (error) {
            console.error("Error loading template:", error);
            if (enqueueSnackbar) {
                enqueueSnackbar("Failed to load template", { variant: "error" });
            }
        }
    };

    const normalizeHardwareDetailsForGeneratedQuote = useCallback(
        (htmlContent) => {
            if (!htmlContent || typeof htmlContent !== "string") return htmlContent;
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlContent, "text/html");
                const headingNodes = Array.from(doc.querySelectorAll("p"));

                headingNodes.forEach((pEl) => {
                    const title = (pEl.textContent || "").trim().toLowerCase();
                    if (title !== "hardware details") return;

                    const sectionWrapper = pEl.parentElement;
                    if (!sectionWrapper) return;

                    const tableEl = sectionWrapper.querySelector("table");
                    if (tableEl) {
                        const rows = Array.from(tableEl.querySelectorAll("tbody tr"));
                        rows.forEach((tr) => {
                            const partInput = tr.querySelector(
                                'input[name^="hardwarePartName_"]'
                            );
                            const qtyInput = tr.querySelector(
                                'input[name^="hardwarePartQty_"]'
                            );
                            if (!partInput && !qtyInput) return;

                            const partVal = String(
                                partInput?.getAttribute("value") ?? partInput?.value ?? ""
                            ).trim();
                            const qtyVal = String(
                                qtyInput?.getAttribute("value") ?? qtyInput?.value ?? ""
                            ).trim();

                            if (partInput) {
                                partInput.parentElement.innerHTML =
                                    partVal || "&nbsp;";
                            }
                            if (qtyInput) {
                                qtyInput.parentElement.innerHTML = qtyVal || "&nbsp;";
                            }
                        });
                    }

                    // Remove add/remove row controls in generated quotation output.
                    const actionButtons = Array.from(
                        sectionWrapper.querySelectorAll("button")
                    );
                    actionButtons.forEach((btn) => btn.remove());
                });

                return doc.body.innerHTML;
            } catch (e) {
                console.warn("Failed to normalize hardware details table:", e);
                return htmlContent;
            }
        },
        []
    );

    const normalizeImageSourcesForGeneratedQuote = useCallback(
        (htmlContent) => {
            if (!htmlContent || typeof htmlContent !== "string") return htmlContent;
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlContent, "text/html");
                const backendUrl = String(configApi?.backendUrl || "").trim();
                const backendOrigin = backendUrl
                    .replace(/\/api\/?$/i, "")
                    .replace(/\/$/, "");

                const imgNodes = Array.from(doc.querySelectorAll("img[src]"));
                imgNodes.forEach((img) => {
                    const rawSrc = String(img.getAttribute("src") || "").trim();
                    if (!rawSrc) return;

                    const isAbsolute =
                        /^https?:\/\//i.test(rawSrc) ||
                        /^data:/i.test(rawSrc) ||
                        /^blob:/i.test(rawSrc);

                    if (!isAbsolute) {
                        const normalizedPath = rawSrc.replace(/^\.?\//, "");
                        const absoluteSrc = backendOrigin
                            ? `${backendOrigin}/${normalizedPath}`
                            : normalizedPath;
                        img.setAttribute("src", absoluteSrc);
                    }
                });

                return doc.body.innerHTML;
            } catch (e) {
                console.warn("Failed to normalize image sources:", e);
                return htmlContent;
            }
        },
        []
    );

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    const handleGenerate = async () => {
        if (!Templateid) {
            enqueueSnackbar("Please select template first", {
                variant: "error",
            });
            return
        }
        
        const isCRM = subscriptionPackage === "CRM";
        let payloadContent = value;

        if (isCRM) {
            const headerHtml = buildQuotationHeaderHtml(resolvedCompanyLogoUrl);
            let bodyHtml = stripCompanyLogoPlaceholderFromHtml(payloadContent || "");
            // IMPORTANT: avoid duplicating the header when editing/regenerating a previous version.
            bodyHtml = stripExistingCrmQuotationHeader(bodyHtml);
            payloadContent = `${headerHtml}${bodyHtml}`;
        }

        if (isCRM && payloadContent) {
            // ReactQuill may not keep typed <input> values in `value` HTML.
            // Patch current DOM input values into `value="..."` so backend receives user-entered data.
            try {
                const quillInstance =
                    quillRef.current?.getEditor?.() || quillRef.current?.editor;
                const rootEl = quillInstance?.root || quillRef.current?.root;

                const inputNodes = rootEl?.querySelectorAll
                    ? rootEl.querySelectorAll(
                        'input[name^="servicePrice_"], input[name^="hardwarePartName_"], input[name^="hardwarePartQty_"]'
                      )
                    : [];

                if (inputNodes && inputNodes.length > 0) {
                    inputNodes.forEach((inputEl) => {
                        const nameAttr = inputEl.getAttribute("name") || "";
                        if (!nameAttr) return;

                        const safeName = nameAttr.replace(
                            /[.*+?^${}()|[\]\\]/g,
                            "\\$&"
                        );
                        const escapedVal = String(inputEl.value ?? "")
                            .replace(/&/g, "&amp;")
                            .replace(/"/g, "&quot;");

                        const valueAttrRegex = new RegExp(
                            `(<input[^>]*name="${safeName}"[^>]*value=")[^"]*(")`,
                            "g"
                        );

                        const before = payloadContent;
                        payloadContent = payloadContent.replace(
                            valueAttrRegex,
                            (m, p1, p2) => `${p1}${escapedVal}${p2}`
                        );

                        if (payloadContent === before) {
                            const inputTagRegex = new RegExp(
                                `<input[^>]*name="${safeName}"[^>]*>`,
                                "g"
                            );
                            payloadContent = payloadContent.replace(
                                inputTagRegex,
                                inputEl.outerHTML
                            );
                        }
                    });
                }
            } catch (e) {
                console.warn("Failed to patch CRM summary input values:", e);
            }

            payloadContent = normalizeHardwareDetailsForGeneratedQuote(payloadContent);
        }

        payloadContent = normalizeImageSourcesForGeneratedQuote(payloadContent);

        const data = {
            type: "GeneratedQuote",
            leadid: leadid,
            templateid: Templateid,
            templatedata: payloadContent,
            jsondata: JSON.stringify(replacedData),
        }
        SetisLoading(true);
        try {
            await dispatch(createQuotation(data)).unwrap();
            setShowVersionHistoryHint(true);
            enqueueSnackbar("Quotation Created Successfully", {
                variant: "success",
                style: { zIndex: 10000 }
            });
        } catch (error) {
            console.error("Failed to create quotation template:", error);
            const errorMessage =
                error?.error ||
                error?.message ||
                "Something went wrong. Please try again.";
            enqueueSnackbar(errorMessage, {
                variant: "error",
                style: { zIndex: 10000 }
            });
        } finally {
            SetisLoading(false);
            dispatch(fetchAllQuotations());
            dispatch(fetchAllQuotationTemplates());
        }
    };

    const handleDownload = async () => {
        if (!downloadid) {
            enqueueSnackbar("Please select template before download", {
                variant: "error",
                style: { zIndex: 10000 }
            });
            return;
        }

        SetisLoading(true);
        try {
            const response = await dispatch(downloadQuotationFile(downloadid));
            const resData = response?.payload;

            if (!resData?.downloadUrl) {
                throw new Error("Download failed");
            }

            const link = document.createElement("a");
            link.href = resData.downloadUrl;

            const extension = resData.contentType?.includes("pdf")
                ? "pdf"
                : "file";

            link.setAttribute("download", `quotation.${extension}`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            enqueueSnackbar("Quotation File Successfully Downloaded", {
                variant: "success",
                style: { zIndex: 10000 }
            });
        } catch (error) {
            enqueueSnackbar(
                error?.message || "Something went wrong. Please try again.",
                {
                    variant: "error",
                    style: { zIndex: 10000 }
                }
            );
        } finally {
            SetisLoading(false);
            setdownloadid(null);
        }
    };

    const handleSend = async () => {
        if (!sendid) {
            enqueueSnackbar("Please select template first", {
                variant: "error",
            });
            return
        }

        SetisLoading(true);
        try {
            await dispatch(sendQuotationToClient({
                leadid: sendid,
                templatedata: value,
            }));
            enqueueSnackbar("The quotation file has been sent successfully", {
                variant: "success",
                style: { zIndex: 10000 }
            });
        } catch (error) {
            console.error("Failed to create quotation template:", error);
            const errorMessage =
                error?.error ||
                error?.message ||
                "Something went wrong. Please try again.";
            enqueueSnackbar(errorMessage, {
                variant: "error",
                style: { zIndex: 10000 }
            });
        } finally {
            SetisLoading(false);
            setValue("")
        }
    };

    const handleExit = () => {
        // In ERP module, after generating quotation, go to Edit Project (step 5)
        if (subscriptionPackage === "ERP" && wizardPlanState === "advancedplan" && wizardProjectState === "existingProject") {
            dispatch(setCreatedProject(createdProject));
            dispatch(goToStep(5)); // Go to step 5 (Edit Project)
        } else {
            // For other cases, exit from wizard and navigate to dashboard
            navigate('/dashboard');
            // Clear all search-related state so user starts fresh
            dispatch(setCreatedProject([]));
            dispatch(resetStep());
            dispatch(setExistingSearchGroupName(""));
            dispatch(setExistingSearchClientName(""));
            dispatch(setExistingSearchProjectName(""));
            dispatch(setExistingProjectLeadId(""));
            dispatch(setExistingSearchQuotationID(""));
            dispatch(setExistingEditAdvancedProject(false));
            dispatch(setcurrentLeadID(""));
            // Show the wizard modal
            dispatch(setShowWizard(true));
        }
    };

    const handleAutosaveQuote = useCallback(async (content) => {
        const isCRM = subscriptionPackage === "CRM";
        const safeContent = isCRM ? sanitizeCrmEditorHtml(content) : content;
        const data = {
            _id: autosaveid,
            type: "AutoSave",
            leadid: leadid,
            templateid: Templateid,
            templatedata: safeContent,
            jsondata: JSON.stringify(replacedData),
        }

        SetisLoading(true);
        try {
            await dispatch(editGenerateQuotation(data));
        } catch (error) {
            console.error("Failed to create quotation template:", error);
            const errorMessage =
                error?.error ||
                error?.message ||
                "Something went wrong. Please try again.";
            enqueueSnackbar(errorMessage, {
                variant: "error",
                style: { zIndex: 10000 }
            });
        } finally {
            SetisLoading(false);
            dispatch(fetchAllQuotations());
            dispatch(fetchAllQuotationTemplates());
        }
    }, [Templateid, leadid, autosaveid, replacedData, enqueueSnackbar, dispatch, subscriptionPackage, sanitizeCrmEditorHtml]);

    const handleQuillChange = useCallback((content) => {
        const isCRM = subscriptionPackage === "CRM";
        const sanitized = isCRM ? sanitizeCrmEditorHtml(content) : content;
        setValue(sanitized);
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        debounceTimeoutRef.current = setTimeout(() => {
            handleAutosaveQuote(sanitized);
        }, 1000);
    }, [handleAutosaveQuote, subscriptionPackage, sanitizeCrmEditorHtml]);

    useEffect(() => {
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (quotations && quotations.length > 0) {
            const filteredQuotations = quotations.filter(q => q.leadid === leadid);
            const autoSaves = filteredQuotations.filter(q => q.type === "AutoSave");
            const sorted = autoSaves.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const latestAutoSave = sorted[0];
            const isCRM = subscriptionPackage === "CRM";
            const restored = latestAutoSave?.templatedata;
            setValue(isCRM ? sanitizeCrmEditorHtml(restored) : restored)
            setautosaveid(latestAutoSave?._id)
        }
    }, [quotations, leadid, subscriptionPackage, sanitizeCrmEditorHtml]);

    return (
        <>
            {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
            <div className="bg-[#f3f8f8] h-full pt-2">
                <div className="w-[99%] bg-white rounded-md p-6">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-lg font-bold">Generate Quotation</h2>
                    </div>
                    <div className='w-full flex justify-between items-end gap-4'>
                        <div className="flex items-end gap-4">
                            <div
                                className="relative inline-block gap-2 justify-center align-middle items-center"
                                ref={groupdownRef}
                            >
                                <label
                                    htmlFor="selectedStatus"
                                    className="block text-sm font-semibold text-gray-700"
                                >
                                    Template
                                </label>
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsTemplateOpen(!isTemplateOpen);
                                    }}
                                    className="w-24 relative outline-none date-picker-placeholder flex justify-start border border-[#e0e7ff] rounded-md p-2 text-xs"
                                >
                                    <span
                                        onClick={() => setAssignedGroup()}
                                        className="truncate min-w-0 flex-1 text-left"
                                    >
                                        {selectedTemplate ? selectedTemplate : "All"}
                                    </span>
                                    <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                                </button>
                                {isTemplateOpen && (
                                    <div className="absolute left-0 top-full w-full text-xs border overflow-hidden text-wrap border-gray-400 bg-white shadow-md rounded-md z-50">
                                        <div
                                            className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === "All" ? "bg-gray-300" : ""
                                                }`}
                                            onClick={() => {
                                                setIsTemplateOpen(false);
                                            }}
                                        >
                                            <label>All</label>
                                        </div>

                                        {template.map((temp) => (
                                            <div
                                                key={temp.id}
                                                className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === temp.newGroupName ? "bg-gray-300" : ""}`}
                                                onClick={() => {
                                                    setIsTemplateOpen(false);
                                                    loadTemplate(temp.templatedataUrl)
                                                    setselectedTemplate(temp.templatename)
                                                    setTemplateid(temp._id)
                                                    setsendid("")
                                                }}
                                            >
                                                <label>{temp.templatename}</label>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <div
                                ref={versionRef}
                                className="relative inline-block gap-2 justify-center align-middle items-center"
                            >
                            <label
                                htmlFor="selectedStatus"
                                className="block text-sm font-semibold text-gray-700"
                            >
                                Version History
                            </label>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setShowVersionHistoryHint(false);
                                    setisHistoryOpen(!isHistoryOpen);
                                }}
                                className={`w-24 relative outline-none date-picker-placeholder flex justify-start rounded-md p-2 pr-7 text-xs transition-all duration-300 ${showVersionHistoryHint
                                    ? "border border-emerald-500 shadow-[0_0_0_3px_rgba(16,185,129,0.18)] animate-pulse"
                                    : "border border-[#e0e7ff]"
                                    }`}
                            >
                                <span
                                    onClick={() => setAssignedGroup()}
                                    className="truncate min-w-0 flex-1 text-left"
                                >
                                    All
                                </span>
                                {showVersionHistoryHint && (
                                    <span className="pointer-events-none absolute right-8 top-1/2 z-10 flex h-2.5 w-2.5 -translate-y-1/2">
                                        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75" />
                                        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500" />
                                    </span>
                                )}
                                <ExpandMoreIcon className="absolute cursor-pointer right-1 top-1 bg-white" />
                            </button>
                            {isHistoryOpen && (
                                <div className="absolute left-0 top-full w-full text-[12px] border border-gray-400 bg-white shadow-md rounded-md z-50 overflow-hidden">
                                    <div
                                        className={`flex items-center p-2 hover:bg-gray-200 cursor-pointer ${AssignedGroup === "All" ? "bg-gray-300" : ""
                                            }`}
                                        onClick={() => {
                                            setIsTemplateOpen(false);
                                        }}
                                    >
                                        <label>All</label>
                                    </div>

                                    {(() => {
                                        // Filter only GeneratedQuote type quotations
                                        const generatedQuotes = quotation.filter(q => q.type === "GeneratedQuote");
                                        // Sort quotations by createdAt in ascending order (oldest first)
                                        const sortedQuotations = [...generatedQuotes].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                                        
                                        return sortedQuotations.map((quot, index) => {
                                            // For ERP package, show leadid_v{versionNumber}
                                            const leadId = selectedLead?.quotationId || createdProject[0]?.quotationId || "";
                                            // Version number: oldest (index 0) gets v1, latest (last index) gets highest version
                                            // First generated quotation stays on v1, v2, etc.
                                            // Latest generated quotation goes to v4, v5, v6, etc.
                                            const versionNumber = index + 1;
                                            const displayText = wizardPlanState === "advancedplan" && leadId 
                                                ? `${leadId}_v${versionNumber}` 
                                                : formatDate(quot.createdAt);
                                            
                                            return (
                                                <div
                                                    key={quot._id}
                                                    className="flex justify-between items-center p-1.5 hover:bg-gray-200 cursor-pointer gap-1"
                                                    onClick={() => {
                                                        setIsTemplateOpen(false);
                                                        if (quot.type === "GeneratedQuote") {
                                                            setFiles(quot.generateddatafilepath)
                                                            setsendid(quot.leadid)
                                                            setdownloadid(quot._id)
                                                        } else {
                                                            const isCRM = subscriptionPackage === "CRM";
                                                            const body = quot.templatedata;
                                                            setValue(isCRM ? sanitizeCrmEditorHtml(body) : body);
                                                        }
                                                        setisHistoryOpen(!isHistoryOpen);
                                                        setselectedTemplate("")
                                                    }}
                                                >
                                                    <span className="flex-1 pr-1 whitespace-nowrap text-[10px]">{displayText}</span>
                                                </div>
                                            );
                                        });
                                    })()}
                                </div>
                            )}
                        </div>
                        </div>

                        <div className=' inline-block p-2 justify-end align-bottom items-end'>
                            <button onClick={handleGenerate} className='px-2 py-1 mr-1 mt-2 text-sm rounded-md bg-[#e32278] text-white inline-block'>
                                Generate
                            </button>

                            <button disabled={quotations.length <= 0} onClick={() => handleDownload()} className='px-2 py-1 mr-1 mt-2 text-sm rounded-md bg-[#e32278] text-white inline-block'>
                                Download
                            </button>
                            <button
                                disabled={quotations.length <= 0}
                                onClick={handleSend}
                                className='px-2 py-1 text-sm rounded-md bg-[#e32278] text-white inline-block'>
                                Send Email
                            </button>
                        </div>
                    </div>
                    <div className='w-full min-h-[5rem] max-h-[24rem] overflow-y-scroll p-2 border mt-2 quotation-quill'>
                        {sendid ? <FileViewer files={files} /> : <div className='preview w-full p-3 shadow-[inset_0_0_10px_rgba(0,0,0,0.3)]'>
                            <div className="quotation-header-ui flex items-start justify-between w-full bg-white">
                                <div className="flex items-center">
                                    {resolvedCompanyLogoUrl ? (
                                        <img
                                            src={resolvedCompanyLogoUrl}
                                            alt="Company Logo"
                                            style={{ maxHeight: 60, width: "auto", objectFit: "contain", display: "block" }}
                                            onError={(e) => {
                                                // fallback to text if image fails
                                                e.currentTarget.style.display = "none";
                                            }}
                                        />
                                    ) : (
                                        <span>Company Logo</span>
                                    )}
                                </div>
                            </div>
                            {value ? (
                                <div className='w-full'>
                                    <ReactQuill
                                        ref={quillRef}
                                        theme="snow"
                                        value={value}
                                        onChange={handleQuillChange}
                                        className='h-[80%] p-2 outline-none rounded-md resize-none'
                                        modules={{
                                            toolbar: [
                                                ['bold', 'italic', 'underline'],
                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                [{ 'font': [] }],
                                                [{ 'align': [] }],
                                                ['image'],
                                            ]
                                        }}
                                        formats={[
                                            'header', 'font', 'size',
                                            'bold', 'italic', 'underline', 'strike', 'blockquote',
                                            'list', 'bullet', 'indent',
                                            'link', 'image', 'video'
                                        ]}
                                    />
                                </div>
                            ) : (
                                <div>
                                    No Template
                                </div>
                            )}

                            {value && (
                                (showfile?.[0]?.message === "No files available for the given Lead ID" ||
                                    showfile?.files?.length === 0
                                ) ? (
                                    <div>No Attachament</div>
                                ) : (
                                    <FilesViewer showfile={showfile} />
                                )
                            )}
                        </div>}

                        <div>
                            <SalesCalculations selectedGroup={selectedGroup} selectedProject={selectedProject} sethtml={sethtml} setfinanaceData={setfinanaceData} setprojectCostMap={setprojectCostMap} />
                        </div>
                    </div>
                </div>

                <div className='w-[99%] flex justify-end mt-4'>
                    <div className="flex gap-4 pt-2">
                        <button
                            onClick={() => {
                                // In ERP module, go back to P&L table (step 4) with "project approved" status
                                if (subscriptionPackage === "ERP" && wizardPlanState === "advancedplan" && wizardProjectState === "existingProject") {
                                    dispatch(setOperationProjectStatus("project approved"));
                                    dispatch(setCreatedProject(createdProject));
                                    dispatch(goToStep(4));
                                } else {
                                    // For other cases, go back to Search Existing Project screen (step 1)
                                    dispatch(goToStep(1));
                                }
                            }}
                            className="bg-black text-white cursor-pointer py-2 px-7 overflow-hidden shadow-md rounded-lg"
                        >
                            Back
                        </button>
                        <button
                            onClick={handleExit}
                            className="bg-[#e32278] text-white cursor-pointer py-2 px-7 overflow-hidden shadow-md rounded-lg"
                        >
                            {subscriptionPackage === "ERP" && wizardPlanState === "advancedplan" && wizardProjectState === "existingProject" ? "Next" : "Exit"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GenerateQuotationWizard

